export function generateHexKey(byteLength=32){
	const array=new Uint8Array(byteLength);
	window.crypto.getRandomValues(array);
	return Array.from(array,(byte)=>{
		return byte.toString(16).padStart(2,'0');
	}).join('');
}